export enum FieldType {
  ANNUAL = 'ANNUAL',
  ARRAY = 'ARRAY',
  BOOLEAN = 'BOOLEAN',
  DATE = 'DATE',
  NUMBER = 'NUMBER',
  TEXT = 'TEXT',
  EMAIL = 'EMAIL',
  PERCENTAGE = 'PERCENTAGE',
}

// TODO: Figure out how to pass in CustomFieldTypes without crashing the app
// import { CustomFieldType } from '@services/communities';
export const FIELD_TYPE_MAP = {
  string: FieldType.TEXT,
  number: FieldType.NUMBER,
  boolean: FieldType.BOOLEAN,
  TEXT: FieldType.TEXT,
  ANNUAL: FieldType.ANNUAL,
  EMAIL: FieldType.EMAIL,
  BOOLEAN: FieldType.BOOLEAN,
  NUMBER: FieldType.NUMBER,
  CURRENCY: FieldType.PERCENTAGE,
  PERCENTAGE: FieldType.PERCENTAGE,
  ARRAY: FieldType.ARRAY,
  DATE: FieldType.DATE,
};
